import { render, staticRenderFns } from "./mobile2.vue?vue&type=template&id=445b9df6&scoped=true&"
import script from "./mobile2.vue?vue&type=script&lang=js&"
export * from "./mobile2.vue?vue&type=script&lang=js&"
import style0 from "./mobile2.vue?vue&type=style&index=0&id=445b9df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b9df6",
  null
  
)

export default component.exports